import { LAYOUT_TYPE } from '@vindr/services/constants/common.constant';
import { MESSAGE } from '@vindr/services/constants/message.constant';
import keycloak from '@vindr/services/keycloak';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';

const TYPE = [
  { name: 'Private', value: LAYOUT_TYPE.PRIVATE },
  { name: 'Public', value: LAYOUT_TYPE.PUBLIC },
];

interface TemplateType extends FormItemProps {
  permissions: string;
}

const TemplateType = ({
  name = 'status',
  label = 'Type',
  placeholder = 'Enter Type',
  rules,
  required = true,
  disabled,
  permissions,
  noStyle,
  ...props
}: TemplateType) => {
  const { t } = useTranslation('Vindoc');

  const TYPE_STATE = useMemo(() => {
    return TYPE;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions]);

  const rulesMemo = useMemo(() => {
    const rulesState = [];

    if (required) rulesState.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
    if (rules) rulesState.push(...rules);

    return rulesState;
  }, [t, rules, required]);

  return (
    <FormSelect
      allowClear={false}
      {...{ name, label, placeholder, disabled, ...props }}
      {...(rules && { rules: rulesMemo })}
      noStyle={noStyle}
    >
      {TYPE_STATE?.map((st) => (
        <Select.Option
          key={st.value}
          value={st.value}
          {...(!keycloak.hasOneOfPerm([permissions]) && st.name === 'Public' && { disabled: true })}
        >
          {t(st.name)}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default TemplateType;
